import {StorageUtil} from "../infra/storageUtil.service";

var angular: angular.IAngularStatic = require('angular');
import {Component, Inject} from 'ng-metadata/core';
import {UserSessionManagerService} from '../security/userSessionManager.service';

import {MediaQueries} from '../infra/mediaQueries.service';
import {getSessionTimeoutParams, getChosenKeepMeSignInConf} from '../appConfig/appConfigForward';
import {PrimoExploreService} from './primoExplore.service';
import {JwtUtilService} from '../security/jwtUtil.service';
import {STATE_NAMES} from "./primoExploreStates.module";
import {CMIntegrationService} from "../cm_integration.service";
import {DigitalPdfStartService} from "../digitalPdfStart.service";
import {ReportProblemService} from "../reportProblem/reportProblem.service";
import {SharedSessionStorage} from "../infra/sharedSessionStorage.service";
import {TimeoutToastService} from "../security/timeoutToast/timeoutToast.service";
import {ConfigurationUtil} from "../nddUtils/configurationUtil.service";
import {DigitalEpubStartService} from "../digitalEpubStart.service";

@Component({
    selector: 'primo-explore',
    template: `<div ui-view></div>
<prm-explore-footer ng-if="!$ctrl.isHiddenState()"></prm-explore-footer>
<prm-silent-login></prm-silent-login><prm-login-iframe></prm-login-iframe>
<prm-report-problem ng-if="$ctrl.isReportProblem()"></prm-report-problem>
<prm-popup-message id="alertTimeout" ng-if="$ctrl.isKeepMeSignInEnabled()"></prm-popup-message>`
})

export class PrimoExplore {
    private warningShowed: boolean;
    private alertObject: angular.material.IDialogOptions;
    private responsiveClass: string;
    private graceTime = getSessionTimeoutParams().warningTime * 1000;
    private MAX_TIMEOUT_SESSION: number = 604800; // 7 days in seconds = 604800
    private TIME_TO_KEEP_DIALOGBOX_DEFAULT: number = 60; // the time in seconds to keep the dialog box
    private TIME_TO_KEEP_DIALOGBOX_SHORT: number = 30; // the time in seconds to keep the dialog box in case the timeout in BO set to 60 seconds 

    constructor(private primoExploreService: PrimoExploreService,
                @Inject('Idle') private Idle: angular.idle.IIdleService,
                @Inject('SessionTimeoutService') private sessionTimeoutService,
                private userSessionManagerService: UserSessionManagerService,
                @Inject('$element') private $element: ng.IAugmentedJQuery,
                @Inject('$mdDialog') private $mdDialog: angular.material.IDialogService,
                @Inject('$mdToast') private $mdToast: ng.material.IToastService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$window') private $window: ng.IWindowService,
                @Inject('$state') private $state: ng.ui.IStateService,
                private jwtUtilService: JwtUtilService,
                private mediaQueries: MediaQueries,
                private storageutil: StorageUtil,
                private cmIntegrationService: CMIntegrationService,
                private reportProblemService: ReportProblemService,
                private digitalPdfStartService: DigitalPdfStartService,
                private sharedSessionStorage: SharedSessionStorage,
                private timeoutToastService: TimeoutToastService,
                private digitalEpubStartService: DigitalEpubStartService,
                private configurationUtil: ConfigurationUtil) {

        //fixes bug with ui-router not switching state due to "transition superseded"
        $scope.$on('$stateChangeCancel', (event, toState, toParams, fromState, fromParams) => {
            if (toState.name === STATE_NAMES.COLLECTION_DISCOVERY) {
                console.log('state transition canceled retrying!');
                $timeout(() => {
                    this.$state.go(toState, toParams, {reload: true, inherit: false});
                }, 0)
            }
        });
        angular.element($window).on('focus', this.handleFocus);

        $scope.$on('IdleWarn', () => this.handleWarning());
        this.warningShowed = false;
        this.userSessionManagerService = userSessionManagerService;
        this.$mdDialog = $mdDialog;
        this.$window = $window;
        this.updateResponsiveClass();
        angular.element($window).bind('resize', () => this.$timeout(() => this.updateResponsiveClass(), 0, false));
        this.updateOgUrl();
        this.digitalPdfStartService.loadPDFCSSAndJavascript();
        this.digitalEpubStartService.loadEpubCSSAndJavascript();
        $translate(['nui.session.timeout.button', 'nui.session.timeout.alert', 'nui.session.timeout.attention']).then((translations) => {
            this.alertObject = $mdDialog.alert({
                textContent: translations['nui.session.timeout.alert'],
                ok: translations['nui.session.timeout.button'],
                title: translations['nui.session.timeout.attention']
            });
        });

    }

    ngOnInit() {
        if (this.isKeepMeSignInEnabled()) {
            let timedOutAfterPopupAppeared = this.sharedSessionStorage.getItem('showDismissAlert');
            if (timedOutAfterPopupAppeared) {
                this.$timeout(() => {
                    // A message will be displayed to the user, notifying him that the session was timed out
                    // The message should disappear after clicking on "Dismiss" or when performing a search or clicking on any other page/state
                    this.showToast();
                    this.sharedSessionStorage.removeItem('showDismissAlert');

                }, 400);
            }
        }
    }

    public updateOgUrl() {
        let urlOgElement = <HTMLMetaElement>document.getElementById('ogURL');
        urlOgElement.content = this.$window.origin;
    }

    $postLink() {
        this.cmIntegrationService.ready();
    }

    public isHiddenState() {
        return this.$state.current.name === STATE_NAMES.EMAIL_TEMPLATE ||
            this.$state.current.name === STATE_NAMES.RAPIDO_VIEWIT ||
            this.$state.current.name === STATE_NAMES.LEGANTO_GETIT;
    }

    private updateResponsiveClass() {
            let newClass = this.mediaQueries.createDynamicClass();
            if (newClass === this.responsiveClass) {
                return;
            }

            if (this.responsiveClass) {
                this.$element.removeClass(this.responsiveClass);
            }
            this.responsiveClass = newClass;
            this.$element.addClass(this.responsiveClass);
    }

    private handleWarning() {
        if (this.isKeepMeSignInEnabled() && !this.jwtUtilService.isGuest()) {
            let chosenConf = getChosenKeepMeSignInConf();
            // The user will receive a message 60 seconds before session timeout
            if(chosenConf != null && (chosenConf == 'extend' || chosenConf == 'extend_max')){
				                let sessionTimeoutInSeconds = getSessionTimeoutParams().userSessionTimeout * 60;
				                sessionTimeoutInSeconds = (sessionTimeoutInSeconds > this.TIME_TO_KEEP_DIALOGBOX_DEFAULT) ? this.TIME_TO_KEEP_DIALOGBOX_DEFAULT : this.TIME_TO_KEEP_DIALOGBOX_SHORT;
                this.showConfirmDialog(sessionTimeoutInSeconds * 1000);
                return;
            }
        }

        this.userSessionManagerService.logout(true); // Nothing was selected, act as before
    }

    public showConfirmDialog(timeout){
        let dialog = document.getElementById('popupDialog') as HTMLDialogElement;
        if(!dialog.open){
            dialog.showModal();
            // Open timeout --> After 60 seconds, in case the user didn't click on any option, logged him out
            // and the page should be refreshed to the main Primo library search page / results page
            this.$timeout(() => {
                if(dialog.open){ // In order to make sure we will perform these steps just in case the dialog is still open
                    this.sharedSessionStorage.setItem('showDismissAlert', 'true');
                    dialog.close();
                    this.userSessionManagerService.logout(true);
                }
            }, timeout);
        }
    }

    public showToast(){
        let templateString = "<prm-timeout-toast></prm-timeout-toast>";
        this.$mdToast.show({
            hideDelay: 0,
            position: 'top right',
            template: templateString
        })
        this.timeoutToastService.showTimeOutToastMessage = true;
    }

    private handleFocus() {
        window.appPerformance.timeStamps['focusIn'] = new Date().getTime();
    }

    public isReportProblem() {
        return this.reportProblemService.isReportProblem();
    }

    public isKeepMeSignInEnabled() {
        let chosenConf = getChosenKeepMeSignInConf();
        
        if(this.configurationUtil.getBackendSystem() === 'suprima'){
            let keepMeSignInFeatureFlag = this.configurationUtil.getFeatureFlag('enable_patrons_to_check_keep_me_signed_in');
            return chosenConf != null && keepMeSignInFeatureFlag;
        }
        
        return chosenConf != null;
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/primoExplore/primoExplore.directive.ts